<template>
  <div>
    <slot name="header">
      <h3 v-if="header" class="table-title">
        {{ header }} <i class="fas fa-spin fa-loader" v-show="loading" />
      </h3>
    </slot>

    <div class="buttons-wrapper margin" v-if="showTabs">
      <base-button
        class="all"
        :class="{
          active:
            filterStatus == null &&
            selectedInspectionAssignedTo == null &&
            selectedInspectionCreator == null,
        }"
        @click="changeSelectedStatus(null)"
      >
        <span class="text">{{ $t("INSPECTIONS.ALL") }}</span>
        <span class="number" v-if="!isNaN(counters.all)">
          {{ counters.all }}
        </span>
      </base-button>
      <base-button
        class="to-do"
        :class="{ active: isTodoTab }"
        @click="
          changeSelectedStatus([
            INSPECTION_STATUS_ASSIGNED,
            INSPECTION_STATUS_PENDING,
          ])
        "
        v-if="
          $currentUserCan(
            this.$permissions.PERM_VIEW_ASSIGNED_TO_GROUP_INSPECTIONS
          ) || $currentUserCan(this.$permissions.PERM_VIEW_ANY_INSPECTIONS)
        "
      >
        <span class="text">{{ $t("COMMON.TODO") }}</span>
        <span class="number" v-if="!isNaN(counters.todo)">
          {{ counters.todo }}
        </span>
      </base-button>
      <base-button
        class="DRAFT"
        :class="{ active: filterStatus == INSPECTION_STATUS_DRAFT }"
        @click="() => changeSelectedStatus(INSPECTION_STATUS_DRAFT)"
        v-if="
          $currentUserCan(this.$permissions.PERM_CREATE_INSPECTIONS) ||
          $currentUserCan(this.$permissions.PERM_VIEW_ANY_INSPECTIONS)
        "
      >
        <span class="text">{{ $t("COMMON.DRAFTS") }}</span>
        <span class="number" v-if="!isNaN(counters.draft)">
          {{ counters.draft }}
        </span>
      </base-button>
      <!-- <base-button
        class="PENDING"
        :class="{
          active: filterStatus == INSPECTION_STATUS_PENDING,
        }"
        @click="() => changeSelectedStatus(INSPECTION_STATUS_PENDING)"
        v-if="
          $currentUserCan(this.$permissions.PERM_APPROVE_INSPECTIONS) ||
          $currentUserCan(this.$permissions.PERM_VIEW_ANY_INSPECTIONS)
        "
      >
        <span class="text">{{ $t("COMMON.PENDING") }}</span>
        <span class="number" v-if="!isNaN(counters.pending)">
          {{ counters.pending }}
        </span>
      </base-button> -->
      <!-- <base-button
        class="ASSIGNED"
        :class="{
          active:
            filterStatus == INSPECTION_STATUS_ASSIGNED &&
            selectedInspectionAssignedTo == null &&
            !selectedAssignedToGroup,
        }"
        @click="() => changeSelectedStatus(INSPECTION_STATUS_ASSIGNED)"
        v-if="
          $currentUserCan(this.$permissions.PERM_START_INSPECTIONS) ||
          $currentUserCan(
            this.$permissions.PERM_VIEW_ASSIGNED_TO_GROUP_INSPECTIONS
          ) ||
          $currentUserCan(this.$permissions.PERM_VIEW_ANY_INSPECTIONS)
        "
      >
        <span class="text">{{ $t("INSPECTIONS.ASSIGNED") }}</span>
        <span class="number" v-if="!isNaN(counters.assigned)">
          {{ counters.assigned }}
        </span>
      </base-button> -->
      <!-- <base-button
        class="IN_PROGRESS"
        :class="{
          active:
            filterStatus == INSPECTION_STATUS_IN_PROGRESS &&
            selectedInspectionAssignedTo != me.id,
        }"
        @click="() => changeSelectedStatus(INSPECTION_STATUS_IN_PROGRESS)"
        v-if="
          $currentUserCan(this.$permissions.PERM_START_INSPECTIONS) ||
          $currentUserCan(
            this.$permissions.PERM_VIEW_ASSIGNED_TO_GROUP_INSPECTIONS
          ) ||
          $currentUserCan(this.$permissions.PERM_VIEW_ANY_INSPECTIONS)
        "
      >
        <span class="text">{{ $t("COMMON.IN_PROGRESS") }}</span>
        <span class="number" v-if="!isNaN(counters.inProgress)">
           {{ counters.inProgress }} 
        </span>
      </base-button> -->
      <base-button
        class="COMPLETED"
        :class="{
          active: filterStatus == INSPECTION_STATUS_COMPLETED,
        }"
        @click="changeSelectedStatus(INSPECTION_STATUS_COMPLETED)"
        v-if="
          $currentUserCan(this.$permissions.PERM_START_INSPECTIONS) ||
          $currentUserCan(
            this.$permissions.PERM_VIEW_ASSIGNED_TO_GROUP_INSPECTIONS
          ) ||
          $currentUserCan(this.$permissions.PERM_VIEW_ANY_INSPECTIONS)
        "
      >
        <span class="text">{{ $t("COMMON.COMPLETED") }}</span>
        <span class="number" v-if="!isNaN(counters.completed)">
          {{ counters.completed }}
        </span>
      </base-button>
      <base-button
        class="CANCELED"
        :class="{
          active: filterStatus == INSPECTION_STATUS_CANCELED,
        }"
        @click="changeSelectedStatus(INSPECTION_STATUS_CANCELED)"
        v-if="$currentUserCan(this.$permissions.PERM_VIEW_ANY_INSPECTIONS)"
      >
        <span class="text">{{ $t("INSPECTIONS.CANCELED") }}</span>
        <span class="number" v-if="!isNaN(counters.canceled)">
          {{ counters.canceled }}
        </span>
      </base-button>
      <!-- <base-button
        class="assign-to-me"
        :class="{
          active:
            filterStatus == INSPECTION_STATUS_ASSIGNED &&
            selectedInspectionAssignedTo == me.id,
        }"
        @click="changeSelectedStatus(INSPECTION_STATUS_ASSIGNED, me.id)"
        v-if="
          $currentUserCan(this.$permissions.PERM_START_INSPECTIONS) ||
          $currentUserCan(this.$permissions.PERM_VIEW_ANY_INSPECTIONS)
        "
      >
        <span class="text">{{ $t("INSPECTIONS.ASSIGNED_TO_ME") }}</span>
        <span class="number" v-if="!isNaN(counters.assignedToMe)">
          {{ counters.assignedToMe }}
        </span>
      </base-button> -->
      <!-- <base-button
        class="to-do"
        :class="{
          active:
            filterStatus == INSPECTION_STATUS_ASSIGNED &&
            selectedAssignedToGroup,
        }"
        @click="
          changeSelectedStatus(INSPECTION_STATUS_ASSIGNED, null, null, true)
        "
        v-if="
          $currentUserCan(
            this.$permissions.PERM_VIEW_ASSIGNED_TO_GROUP_INSPECTIONS
          ) || $currentUserCan(this.$permissions.PERM_VIEW_ANY_INSPECTIONS)
        "
      >
        <span class="text">{{ $t("COMMON.TODO") }}</span>
        <span class="number" v-if="!isNaN(counters.todo)">
          {{ counters.todo }}
        </span>
      </base-button> -->
      <!-- <base-button
        class="by-me"
        :class="{
          active: selectedInspectionCreator == me.id,
        }"
        @click="changeSelectedStatus(null, null, me.id)"
        v-if="
          $currentUserCan(this.$permissions.PERM_CREATE_INSPECTIONS) ||
          $currentUserCan(this.$permissions.PERM_VIEW_ANY_INSPECTIONS)
        "
      >
        <span class="text">{{ $t("INSPECTIONS.CREATED_BY_ME") }}</span>
        <span class="number" v-if="!isNaN(counters.createdByMe)">
          {{ counters.createdByMe }}
        </span>
      </base-button> -->

      <i class="fas fa-spin fa-loader" v-if="loading" />
    </div>

    <div class="list-table-inner-body">
      <div class="list-table-inner-body-inner">
        <el-table
          class="align-items-center table-flush inspections"
          header-row-class-name="thead-light has-image"
          :data="inspections"
          @sort-change="sortChange"
          :row-class-name="setDeletedClass"
          @row-click="
            (row) => {
              viewInspection(row);
            }
          "
        >
          <div class="table-loading" slot="empty" v-if="loading">
            <img src="/img/loading.gif" />
          </div>

          <el-table-column
            v-if="canViewColumn('vehicle')"
            width="75"
            cell-class-name="pic"
          >
            <template v-slot="{ row }">
              <div class="image" v-if="row.vehicle">
                <img
                  v-if="row.vehicle?.gallery?.length > 0"
                  :src="row.vehicle?.gallery[0]"
                  class="avatar rounded-circle mr-3"
                />
                <span class="default-icon">
                  <i class="far fa-camera"></i>
                </span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            v-if="canViewColumn('vehicle')"
            :label="$t('COMMON.VEHICLE')"
            min-width="200"
          >
            <template v-slot="{ row }">
              <div class="vehicle">
                <ul class="no-line">
                  <li>{{ row?.vehicle?.make }} {{ row?.vehicle?.model }}</li>
                  <li>{{ row?.vehicle?.model_year }}</li>
                </ul>
                <ul>
                  <li v-if="row?.vehicle?.series">
                    {{ row?.vehicle?.series }}
                  </li>
                  <li class="line" v-if="row?.vehicle?.series">|</li>
                  <li v-if="row?.vehicle?.color">{{ row?.vehicle?.color }}</li>
                  <li class="line" v-if="row?.vehicle?.color">|</li>
                  <li>
                    {{ row?.vehicle?.odometer ?? 0 }}
                    {{ row?.vehicle?.odometer_unit }}
                  </li>
                </ul>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            v-if="canViewColumn('vin')"
            :label="$t('VEHICLES.SKU') + ' / ' + $t('VEHICLES.VIN')"
            prop="sku"
            min-width="200"
          >
            <template v-slot="{ row }">
              <div class="stock">
                <ul>
                  <li v-if="row.vehicle?.sku">{{ row?.vehicle?.sku }}</li>
                  <li><copy-element :element="row.vehicle?.vin" /></li>
                </ul>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            v-if="canViewColumn('customer')"
            :label="$t('REPAIRS.CLIENT_WORK_ORDER')"
            min-width="150"
          >
            <template v-slot="{ row }">
              <div class="client">
                <ul v-if="!!row.customer">
                  <li>
                    {{ $objectDenomination(row.customer) }}
                  </li>
                  <li>{{ row.work_order }}</li>
                </ul>
                <ul v-if="!!row.approver">
                  <li>
                    {{ $t("COMMON.INTERNAL") }}
                  </li>
                  <li>{{ row.work_order }}</li>
                </ul>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            v-if="canViewColumn('model')"
            :label="$t('INSPECTIONS.CODE')"
            prop="code"
            min-width="150"
            sortable="custom"
          >
            <template v-slot="{ row }">
              <div class="code">
                <ul>
                  <li>{{ row.code }}</li>
                  <li><object-link :object="row.inspectionForm" /></li>
                </ul>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            v-if="canViewColumn('status')"
            :label="$t('COMMON.STATUS')"
            prop="status"
            min-width="180"
          >
            <template v-slot="{ row }">
              <inspection-status-badge :inspection="row" />
            </template>
          </el-table-column>

          <el-table-column
            v-if="canViewColumn('mechanic')"
            :label="$t('INSPECTIONS.MECHANICS')"
            min-width="150"
          >
            <template v-slot="{ row }">
              <users :users="row.assignedToUsers" />
            </template>
          </el-table-column>

          <el-table-column
            v-if="canViewColumn('official_mechanic')"
            :label="$t('INSPECTIONS.OFFICIAL_MECHANIC')"
            min-width="150"
          >
            <template v-slot="{ row }">
              <object-link
                :object="row.completedBy"
                v-if="$currentUserCan($permissions.PERM_VIEW_USERS)"
              />
              <span v-else>{{ $objectDenomination(row.completedBy) }}</span>
            </template>
          </el-table-column>

          <el-table-column
            v-if="canViewColumn('picture_count')"
            :label="$t('INSPECTIONS.PICTURE_COUNT')"
            min-width="100"
          >
            <template v-slot="{ row }">
              <span>{{ row.picture_count }}</span>
            </template>
          </el-table-column>

          <el-table-column
            v-if="canViewColumn('updated_at')"
            :label="$t('INSPECTIONS.UPDATED_AT')"
            prop="updated_at"
            sortable="custom"
            min-width="150"
          >
            <template v-slot="{ row }">
              {{ $timeZoneDateFormat(row.updated_at, "L LT") }}
            </template>
          </el-table-column>

          <el-table-column
            v-if="canViewColumn('completed_at')"
            :label="$t('INSPECTIONS.COMPLETED_AT')"
            prop="completed_at"
            sortable="custom"
            min-width="150"
          >
            <template v-slot="{ row }">
              {{
                row.completed_at
                  ? $timeZoneDateFormat(row.completed_at, "L LT")
                  : "-"
              }}
            </template>
          </el-table-column>

          <el-table-column fixed="right" min-width="120">
            <template v-slot="{ row }">
              <div class="table-actions" v-if="!isDeleted(row)">
                <el-tooltip
                  :content="$t('INSPECTIONS.GENERATE_REPORT')"
                  placement="top"
                  :class="{
                    disabled: !canGenerateInspectionReport(row),
                  }"
                >
                  <a
                    type="text"
                    class="table-action view"
                    data-toggle="tooltip"
                    @click.stop="downloadInspectionReport(row)"
                  >
                    <i class="fal fa-file-pdf"></i>
                  </a>
                </el-tooltip>
                <el-tooltip :content="$t('COMMON.VIEW')" placement="top">
                  <a
                    type="text"
                    class="table-action view"
                    data-toggle="tooltip"
                    @click.stop="viewInspection(row)"
                  >
                    <i
                      class="fa-light fa-arrow-up-right-and-arrow-down-left-from-center"
                    ></i>
                  </a>
                </el-tooltip>

                <el-tooltip
                  :content="$t('COMMON.SHARE')"
                  placement="top"
                  v-if="canShareInspection(row)"
                >
                  <a
                    type="text"
                    class="table-action delete"
                    data-toggle="tooltip"
                    @click.stop="shareInspection(row)"
                  >
                    <i class="fal fa-share"></i>
                  </a>
                </el-tooltip>
                <el-tooltip
                  :content="$t('COMMON.DELETE')"
                  placement="top"
                  :class="{
                    disabled: !canDeleteInspection(row),
                  }"
                  v-else
                >
                  <a
                    type="text"
                    class="table-action delete"
                    data-toggle="tooltip"
                    @click.stop="deleteInspection(row)"
                  >
                    <i class="fa-light fa-trash-can"></i>
                  </a>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div
      class="list-table-inner-footer"
      v-if="showPagination || total > pagination.perPage"
    >
      <p class="card-category">
        {{
          $t("COMMON.DISPLAY_FROM_X_TO_X_OF_X_ENTRIES", {
            from: total ? from + 1 : 0,
            to: to,
            of: total,
          })
        }}
        <span v-if="selectedRows.length">
          &nbsp; &nbsp;
          {{ $t("COMMON.X_LINES_SELECTED", { count: selectedRows.length }) }}
        </span>
      </p>
      <base-pagination
        class="pagination-no-border"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      />
    </div>
  </div>
</template>

<script>
import _, { cloneDeep } from "lodash";
import CopyElement from "@/components/CopyElement.vue";
import Users from "@/components/Users.vue";
import InspectionStatusBadge from "./InspectionStatusBadge.vue";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { BasePagination } from "@/components";
import {
  INSPECTION_STATUS_DRAFT,
  INSPECTION_STATUS_APPROVED,
  INSPECTION_STATUS_ASSIGNED,
  INSPECTION_STATUS_COMPLETED,
  INSPECTION_STATUS_CANCELED,
  INSPECTION_STATUS_PENDING,
  INSPECTION_STATUS_IN_PROGRESS,
} from "@/constants/inspections";
import swal from "sweetalert2";
import inspectionsService from "@/store/services/inspections-service";
import trashedMixin from "@/mixins/trashed-mixin";
import inspecproPdfsMixin from "@/mixins/inspecpro-pdfs-mixin";

export default {
  name: "inspection-table",

  components: {
    BasePagination,
    Users,
    CopyElement,
    InspectionStatusBadge,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
  },

  mixins: [trashedMixin, inspecproPdfsMixin],

  props: {
    header: {
      type: String | Boolean | null | undefined,
      default: null,
    },
    showTabs: {
      type: Boolean,
      default: false,
    },
    // pagination: {
    //   type: Object,
    //   default: () => ({
    //     perPage: 20,
    //     currentPage: 1,
    //     perPageOptions: [20, 50, 100, 500],
    //   }),
    // },
    showPagination: {
      type: Boolean,
      default: true,
    },
    filterStatus: {
      type: [String, Array],
      default: null,
      description: "Status",
    },
    filterOdometer: {
      type: [String, Array, Object],
      default: null,
      description: "Odometer",
    },
    selectedDateRange: {
      type: Array | String | Date | null,
      default: null,
    },
    excludeStatus: {
      type: String,
      default: null,
    },
    selectedCompletedBy: {
      type: String,
      default: null,
    },
    selectedCreator: {
      type: String,
      default: null,
    },
    selectedCustomer: {
      type: String,
      default: null,
    },
    filterVehicle: {
      type: String,
      default: null,
      description: "Vehicle id",
    },
    selectedVehicleModelYear: {
      type: [String, Number, Array],
      default: null,
    },
    selectedVehicleMake: {
      type: String,
      default: null,
    },
    selectedVehicleModel: {
      type: String,
      default: null,
    },
    selectedVehicleSeries: {
      type: String,
      default: null,
    },
    selectedOrganization: {
      type: String,
      default: null,
    },
    selectedInspectionForm: {
      type: String,
      default: null,
    },
    selectedLocations: {
      type: String,
      default: null,
    },
    selectedAssignedBy: {
      type: String,
      default: null,
    },
    selectedAssignedTo: {
      type: String,
      default: null,
    },
    selectedAssignedToGroup: {
      type: String,
      default: null,
    },
    selectedCanceledBy: {
      type: String,
      default: null,
    },
    perPage: {
      type: Number,
      default: 20,
    },
    query: {
      type: String,
      default: null,
    },
    columns: {
      type: Array | null,
      default: () => [
        "vehicle",
        "vin",
        "customer",
        "model",
        "status",
        "mechanic",
        "picture_count",
        "official_mechanic",
        "updated_at",
      ],
    },
    onlyTrashed: {
      type: Boolean,
      default: false,
    },
  },

  created() {},

  data() {
    return {
      selectedRows: [],
      sort: "-updated_at",
      total: 0,
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [20, 50, 100, 500],
      },
      inspections: [],
      loading: true,
      selectedTags: [],
      // selectedAssignedToGroup: false,
      selectedInspectionAssignedTo: null,
      selectedInspectionCreator: null,
      INSPECTION_STATUS_DRAFT,
      INSPECTION_STATUS_APPROVED,
      INSPECTION_STATUS_ASSIGNED,
      INSPECTION_STATUS_COMPLETED,
      INSPECTION_STATUS_CANCELED,
      INSPECTION_STATUS_PENDING,
      INSPECTION_STATUS_IN_PROGRESS,
      counters: {
        createdByMe: 0,
        todo: 0,
        all: 0,
        draft: 0,
        pending: 0,
        assigned: 0,
        inProgress: 0,
        completed: 0,
        canceled: 0,
        assignedToMe: 0,
      },
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },

    params() {
      let params = {
        ...(this.sort ? { sort: this.sort } : {}),
        filter: {
          ...(this.query ? { search: this.query } : {}),
        },
        page: {
          number: this.pagination.currentPage,
          size: this.pagination.perPage,
        },
        include:
          "organization,creator,customer,approver,allowedLocations,tags,inspectionForm,vehicle,completedBy,assignedToUsers",
      };

      if (this.filterStatus) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            status: this.filterStatus,
          },
        };
      }

      if (this.filterOrganization) {
        params = {
          ...params,
          filter: { ...params.filter, organization: this.filterOrganization },
        };
      }

      if (this.selectedOrganization) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            organization: this.selectedOrganization,
          },
        };
      }

      if (this.filterOdometer.from) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            odometer_from: this.filterOdometer.from,
          },
        };
      }

      if (this.filterOdometer.to) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            odometer_to: this.filterOdometer.to,
          },
        };
      }

      if (this.filterCustomer) {
        params = {
          ...params,
          filter: { ...params.filter, customer: this.filterCustomer },
        };
      }
      if (this.selectedCustomer) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            organization: this.selectedCustomer,
          },
        };
      }

      if (this.filterInspectionForm) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            inspectionForm: this.filterInspectionForm,
          },
        };
      }
      if (this.selectedInspectionForm) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            inspectionForm: this.selectedInspectionForm,
          },
        };
      }
      if (this.selectedLocations) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            allowedLocations: this.selectedLocations.map((loc) => loc.id),
          },
        };
      }
      if (this.selectedTags) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            tags: this.selectedTags.map((item) => item.id),
          },
        };
      }

      if (this.selectedDateRange) {
        if (this.selectedDateRange.length == 2) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              created_at: [
                this.selectedDateRange[0] + " 00:00:00",
                this.selectedDateRange[1] + " 23:59:59",
              ],
            },
          };
        }
      }

      if (this.filterAssignedTo) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            assignedToUsers: this.filterAssignedTo,
          },
        };
      }

      if (this.filterAssignedToGroup) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            assignedToRoles: this.filterAssignedToGroup,
          },
        };
      }

      if (this.selectedAssignedTo) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            assignedToUsers: this.selectedAssignedTo,
          },
        };
      }

      if (this.selectedAssignedBy) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            assignedBy: this.selectedAssignedBy,
          },
        };
      }

      if (this.selectedAssignedToGroup) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            assignedToRoles: this.selectedAssignedToGroup,
          },
        };
      }

      if (this.selectedCanceledBy) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            canceledBy: this.selectedCanceledBy,
          },
        };
      }

      if (this.selectedCompletedBy) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            completedBy: this.selectedCompletedBy,
          },
        };
      }

      if (this.filterCreator) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            creator: this.filterCreator,
          },
        };
      }

      if (this.selectedCreator) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            creator: this.selectedCreator,
          },
        };
      }

      if (this.filterVehicle) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            vehicle: this.filterVehicle,
          },
        };
      }

      if (this.selectedVehicleModelYear) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            vehicle: {
              ...params.filter?.vehicle,
              model_year: this.selectedVehicleModelYear,
            },
          },
        };
      }

      if (this.selectedVehicleMake) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            vehicle: {
              ...params.filter?.vehicle,
              make: this.selectedVehicleMake,
            },
          },
        };
      }

      if (this.selectedVehicleModel) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            vehicle: {
              ...params.filter?.vehicle,
              model: this.selectedVehicleModel,
            },
          },
        };
      }

      if (this.selectedVehicleSeries) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            vehicle: {
              ...params.filter?.vehicle,
              series: this.selectedVehicleSeries,
            },
          },
        };
      }

      if (this.excludeStatus) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            excludeStatus: this.excludeStatus,
          },
        };
      }

      if (this.onlyTrashed) {
        params = {
          ...params,
          filter: {
            ...params.filter,
            only_trashed: true,
          },
        };
      }

      return params;
    },

    isTodoTab() {
      return (
        Array.isArray(this.filterStatus) &&
        this.filterStatus.includes(INSPECTION_STATUS_ASSIGNED) &&
        this.filterStatus.includes(INSPECTION_STATUS_PENDING)
      );
    },
  },

  async created() {
    await this.getList();

    if (this.showTabs) {
      this.getCounters();
    }
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      // this.inspections = [];
      this.loading = true;

      try {
        let params = this.params;

        const { list, meta } = await inspectionsService.list(
          params,
          this.$axios
        );

        this.inspections = list;
        this.total = meta.page.total;
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      } finally {
        this.loading = false;
      }
    },

    async getCounters() {
      const data = await inspectionsService.getCount(this.params);

      const all = Object.values(data).reduce((acc, val) => acc + val, 0);

      const {
        [INSPECTION_STATUS_ASSIGNED]: assign = 0,
        [INSPECTION_STATUS_DRAFT]: draft = 0,
        [INSPECTION_STATUS_PENDING]: pending = 0,
        [INSPECTION_STATUS_CANCELED]: canceled = 0,
        [INSPECTION_STATUS_COMPLETED]: completed = 0,
        [INSPECTION_STATUS_IN_PROGRESS]: inProgress = 0,
      } = data;

      this.counters = {
        ...this.counters,
        all,
        todo: assign + pending,
        draft,
        pending,
        canceled,
        completed,
        inProgress,
      };
    },

    canViewColumn(column) {
      if (!this.columns || !Array.isArray(this.columns)) return true;

      return this.columns?.includes(column);
    },

    changeSelectedStatus(
      status,
      assignedTo = null,
      creator = null,
      group = false
    ) {
      // this.filterStatus = status;
      // setStatus(status);
      this.$emit("setStatus", status);
      // this.selectedInspectionAssignedTo = assignedTo;
      // this.selectedInspectionCreator = creator;
      // this.selectedAssignedToGroup = group;
    },

    shareInspection(inspection) {
      this.$emit("onShareInspection", inspection);
    },

    async deleteInspection(inspection) {
      if (!this.canDeleteInspection(inspection)) {
        return;
      }
      const confirmation = await swal.fire({
        title: this.$t("INSPECTIONS.DELETE_THIS_INSPECTION"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.isConfirmed) {
          swal.showLoading();
          await this.$store.dispatch("inspections/destroy", inspection.id);
          await this.getList();
          this.$notify({
            type: "success",
            timeout: 3000,
            message: this.$t("INSPECTIONS.INSPECTION_DELETED"),
          });
        }
        swal.close();
        await this.getList();
      } catch (error) {
        swal.close();
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    viewInspection(inspection) {
      if (this.isDeleted(inspection)) {
        return;
      }
      this.$emit("onViewInspection", inspection);
    },

    editInspection(inspection) {
      if (!this.canEditInspection(inspection)) {
        return;
      }
      this.$emit("onEditInspection", inspection);
    },

    addInspection() {
      this.$emit("onAddInspection");
    },

    canEditInspection(inspection) {
      return (
        !!inspection &&
        ![INSPECTION_STATUS_CANCELED, INSPECTION_STATUS_COMPLETED].includes(
          inspection.status
        ) &&
        (this.$currentUserCan(this.$permissions.PERM_EDIT_INSPECTIONS) ||
          this.$currentUserCan(this.$permissions.PERM_APPROVE_INSPECTIONS) ||
          this.$currentUserCan(this.$permissions.PERM_ASSIGN_INSPECTIONS))
      );
    },

    canDeleteInspection(inspection) {
      return (
        !!inspection &&
        inspection.status == INSPECTION_STATUS_DRAFT &&
        this.$currentUserCan(this.$permissions.PERM_DELETE_INSPECTIONS)
      );
    },

    canShareInspection(inspection) {
      return (
        !!inspection &&
        !!inspection.share_key &&
        inspection.status == INSPECTION_STATUS_COMPLETED
      );
    },

    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },
  },

  watch: {
    params: {
      handler: async function (value, oldValue) {
        if (_.isEqual(value, oldValue)) return;

        await this.getList();

        if (this.showTabs && value.filter.status == oldValue.filter.status) {
          this.getCounters();
        }
      },
      immediate: false,
      deep: true,
    },

    perPage: function (perPage) {
      this.pagination = { ...this.pagination, perPage };
    },
  },
};
</script>
